export const FeatureFlags = {
  // Standalone HealthKey shop (/healthkey) and its sidebar entries.
  // Turn back on to expose the page again - it gates the route and both sidebars together.
  HealthKeyShop: false,
};

export default FeatureFlags;
